import { FC } from "react";
import { useProfileCommission } from "../../context/ProfileCommissionContext/ProfileCommisionContext";
import "./totalCommision.css";
import { formatearPesoMXN } from "../../utils/format";
import { Tooltip } from "@mui/material";

interface IProps {}

export const TotalCommission: FC<IProps> = (props) => {
  const { commission, loading } = useProfileCommission();

  return (
    <Tooltip title="Comisión total" placement="bottom">
      <div className="commission-chip">
        <span className="commission-text">
          Comisión: {formatearPesoMXN(commission?.totalCost || 0)}
        </span>
      </div>
    </Tooltip>
  );
};
